<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.xs" persistent max-width="600px" >
    <template v-slot:activator="{ on }">
    <v-btn v-on="on" color="primary" class=" white--text elevation-1">
        <v-icon left>add</v-icon>{{titleBtn}}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense class="elevation-0 amber darken-1 white--text">
        <v-toolbar-title class="ml-2">TẠO HÓA ĐƠN</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel" >close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <bill-form ref="form"></bill-form>
        <div class="d-flex justify-end">
          <v-btn class ="px-6" color="primary" large depressed dark @click="create" :loading="loading">lƯU ĐƠN</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BillForm from '@/components/basic/form/BillNewForm.vue'

export default {
  components: { BillForm },
  props: {},
  data: () => ({
    loading: false,
    dialog: false,
    title_btn: '',
  }),
  beforeDestroy () {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize, { passive: true })
  },

  mounted () {
    this.onResize()

    window.addEventListener('resize', this.onResize, { passive: true })
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('app', ['department']),
    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
      case 'xs':
      case 'sm':
        return 'Tạo'
      default:
        return 'Tạo hóa đơn'
      }
    },
  },
  methods: {
    ...mapActions('bill', ['createBill']),
    cancel () {
      this.dialog = false
      this.$refs.form.reset()
    },
    async create () {
      this.loading = true
      const bill = this.$refs.form.getValues()
      await this.createBill({
        data: {
          ...bill,
          staff: this.profile.id,
          department: this.department.id
        }
      })
      this.dialog = false
      this.loading = false
    },
    onResize() {
      if (window.innerWidth < 600) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
  }
}
</script>
<style scoped>
</style>
